/*
 * Copyright (c) 2026
 */
import { useCallback, useEffect, useRef, useState } from 'react'
import { HolidayPortal } from '../holiday-portal'
import { attachSnowEffect } from './snow-webgl'

const SnowEffect = () => {
  const canvasRef = useRef<HTMLCanvasElement | null>(null)
  const [canvasMounted, setCanvasMounted] = useState(false)

  const setCanvasRef = useCallback((node: HTMLCanvasElement | null) => {
    canvasRef.current = node
    setCanvasMounted(node !== null)
  }, [])

  useEffect(() => {
    if (!canvasMounted) {
      return
    }
    const canvas = canvasRef.current
    if (!canvas) {
      return
    }
    return attachSnowEffect(canvas)
  }, [canvasMounted])

  return (
    <HolidayPortal>
      <canvas aria-hidden className="pointer-events-none fixed inset-0 z-max h-screen w-screen" ref={setCanvasRef} />
    </HolidayPortal>
  )
}

export default SnowEffect
